module.exports = __webpack_public_path__ + "img/maps-route.ee89cf8d.svg";